/** Line types for caller ID selection */
export enum CallerIdLineType {
  DEFAULT_CLID = 'defaultCLID',
  ADDITIONAL_NUMBER = 'additionalNumber',
  CALL_CENTER_DNIS = 'callCenterDNIS',
  HUNT_GROUP = 'huntGroup',
}

/** A caller ID option within a line (for lines with multiple caller IDs) */
export interface ICallerIdOption {
  callerIdIndex: number;    // 0-based index within the parent line
  name: string;             // Caller ID display name
  number: string;           // Phone number/extension
  isSelected: boolean;      // Whether this caller ID is the active one
}

/** Parsed line info for UI display */
export interface ILineSelectionInfo {
  lineIndex: number;        // 0-based index for display ordering
  lineLabel: string;        // "L1", "L2", "L3", etc.
  title: string;            // Display name: "Primary Number", "Virtual for Call Queue", etc.
  number: string;           // Phone number/extension
  lineType: CallerIdLineType;
  isSelected: boolean;      // Whether this line is currently selected for outgoing

  // Phone Services GUID — used as lineId in cross-launch URL for robustness against line re-ordering
  lineGuid?: string;

  // Service-specific identifiers
  serviceUserId?: string;   // For CALL_CENTER_DNIS and HUNT_GROUP types
  dnisName?: string;        // For CALL_CENTER_DNIS type

  // Multiple caller IDs per line (optional — most lines have a single implicit caller ID)
  callerIds?: ICallerIdOption[];
}

/** Parsed response from line data fetch */
export interface ICallerIdResponse {
  currentSelection: CallerIdLineType;
  currentSelectionValue?: string;
  lines: ILineSelectionInfo[];
}
